{
  "instances": {
    "liquibase": {
      "label": "Liquibase",
      "author": "Autor",
      "changelog": "Changelog",
      "checksum": "Prüfsumme",
      "comments": "Kommentare",
      "contexts": "Kontexte",
      "deployment_id": "Deployment Id",
      "description": "Beschreibung",
      "execution": "Ausführung",
      "execution_date": "Ausführungs-Datum",
      "execution_order": "Reihenfolge",
      "id": "Id",
      "labels": "Label",
      "tag": "Tag"
    }
  }
}
